//import * as Zulamodule from "./module_exports";

export const apiHash = {
    dataset_stats:process.env.REACT_APP_API_URL + "/dataset/stats"
};


